import React from 'react'
import { useTranslation } from 'react-i18next'

import { Tag } from 'primereact/tag'
import { TagProps } from 'primereact/tag'

import { EinvoiceValidationresult } from '../../../../data/models'

type Props = {
  level?: EinvoiceValidationresult['Level']
}

export const LevelTag: React.FC<Props> = ({ level }) => {
  const { t } = useTranslation()

  if (!level) return null

  const getIcon = (): string => {
    switch (level) {
      case 'Error':
        return 'pi pi-times'
      case 'DisabledError':
        return 'pi pi-exclamation-circle'
      case 'Warn':
        return 'pi pi-exclamation-triangle'

      case 'Success':
        return 'pi pi-check'
      default:
        return 'pi pi-info-circle'
    }
  }

  const getSeverity = (): TagProps['severity'] => {
    switch (level) {
      case 'Error':
        return 'danger'
      case 'Warn':
        return 'warning'
      case 'Success':
        return 'success'
      case 'DisabledError':
      default:
        return 'info'
    }
  }

  return (
    <Tag
      icon={getIcon()}
      severity={getSeverity()}
      value={t(`eInvoiceDetails.common.level.${level}`)}
    />
  )
}
